module.exports = __webpack_public_path__ + "img/icon_5.459052a2.svg";